import React from "react"
import PropTypes from "prop-types"
import ReactMarkdown from "react-markdown"
import { Container } from "./styles"
import { H1, H2, H3, P } from "../typography"
import gfm from "remark-gfm"
import rehypeRaw from "rehype-raw"
import { ButtonA, Img, Table, Details, Li, A } from "./styles"

const defaultComponentStyles = {
  p: { variant: "content" },
  h1: { variant: "content" },
  h2: { variant: "content" },
  h3: { variant: "content" },
  img: { variant: "content" },
  table: { variant: "content" },
  details: { variant: "content" },
  li: { variant: "content" },
  a: { variant: "content" }
}

const Markdown = ({ children, componentStyles, ...rest }) => {
  const mergedComponentStyles = {
    p: {
      ...defaultComponentStyles.p,
      ...componentStyles.generic,
      ...componentStyles.p
    },
    h1: {
      ...defaultComponentStyles.h1,
      ...componentStyles.generic,
      ...componentStyles.h1
    },
    h2: {
      ...defaultComponentStyles.h2,
      ...componentStyles.generic,
      ...componentStyles.h2
    },
    h3: {
      ...defaultComponentStyles.h3,
      ...componentStyles.generic,
      ...componentStyles.h3
    },
    img: {
      ...defaultComponentStyles.img,
      ...componentStyles.generic,
      ...componentStyles.img
    },
    table: {
      ...defaultComponentStyles.table,
      ...componentStyles.generic,
      ...componentStyles.table
    },
    details: {
      ...defaultComponentStyles.details,
      ...componentStyles.generic,
      ...componentStyles.details
    },
    li: {
      ...defaultComponentStyles.li,
      ...componentStyles.generic,
      ...componentStyles.li
    },
    a: {
      ...defaultComponentStyles.a,
      ...componentStyles.generic,
      ...componentStyles.a
    }
  }

  const components = {
    p: ({ children, ...other }) => (
      <P {...other} {...mergedComponentStyles.p}>
        {children}
      </P>
    ),
    pre: ({ children, ...other }) => (
      <P {...other} {...mergedComponentStyles.p}>
        {children}
      </P>
    ),
    h1: ({ children, ...other }) => (
      <H1 {...other} {...mergedComponentStyles.h1}>
        {children}
      </H1>
    ),
    h2: ({ children, ...other }) => (
      <H2 {...other} {...mergedComponentStyles.h2}>
        {children}
      </H2>
    ),
    h3: ({ children, ...other }) => (
      <H3 {...other} {...mergedComponentStyles.h3}>
        {children}
      </H3>
    ),
    img: ({ ...other }) => <Img {...other} {...mergedComponentStyles.img} />,
    table: ({ children, ...other }) => (
      <Table {...other} {...mergedComponentStyles.table}>
        {children}
      </Table>
    ),
    details: ({ children, ...other }) => (
      <Details {...other} {...mergedComponentStyles.details}>
        {children}
      </Details>
    ),
    li: ({ children, ...other }) => (
      <Li {...other} {...mergedComponentStyles.li}>
        {children}
      </Li>
    ),
    a: ({ children, ...other }) =>
      other.className === "cta" ? (
        <ButtonA variant="primary" {...other}>
          {children}
        </ButtonA>
      ) : (
        <A {...other} {...mergedComponentStyles.a}>
          {children}
        </A>
      )
  }

  return (
    <Container {...rest}>
      <ReactMarkdown
        remarkPlugins={[gfm]}
        rehypePlugins={[rehypeRaw]}
        linkTarget="_blank"
        components={components}
        children={children}
      />
    </Container>
  )
}

Markdown.propTypes = {
  children: PropTypes.node,
  componentStyles: PropTypes.object
}

Markdown.defaultProps = {
  componentStyles: {}
}

export default Markdown
